import React from 'react';
import './GrnPage.css'; // Use the shared CSS for styling

const ViewGrnModal = ({ grn, onClose }) => {
    
    // Helper to format currency
    const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);

    // This function prevents the modal from closing if you click inside the content area
    const handleContentClick = (e) => e.stopPropagation();

    return (
        // The dark overlay that covers the page. Clicking it calls onClose.
        <div className="modal-overlay" onClick={onClose}>
            {/* The white modal box */}
            <div className="modal-content" onClick={handleContentClick}>
                <div className="modal-header">
                    <h2>GRN Details ...</h2>
                    <button className="modal-close-button" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    {/* Main GRN Details */}
                    <div className="grn-detail-item"><strong>Purchase Date:</strong> {grn.purchaseDate}</div>
                    <div className="grn-detail-item"><strong>Added By:</strong> {grn.addedBy}</div>
                    <div className="grn-detail-item"><strong>Total Price:</strong> {formatPrice(grn.totalPurchasePrice)}</div>
                    <div className="grn-detail-item">
                        <strong>Bill/Invoice:</strong>
                        {/* This link now handles both Base64 data and a regular URL */}
                        <a 
                            href={grn.billData || grn.billUrl} 
                            download={grn.billFileName || 'bill.png'} 
                            className="view-bill-link modal-bill-link"
                            target={grn.billUrl ? "_blank" : "_self"} // Open URL in new tab
                            rel="noopener noreferrer"
                        >
                            {grn.billUrl ? 'View Bill' : 'Download Bill'}
                        </a>
                    </div>
                    
                    <h4 className="items-header">Items Received</h4>
                    {/* Table for the list of items */}
                    <table className="grn-items-table modal-items-table">
                        <thead>
                            <tr>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th>Unit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {grn.items && grn.items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.productName}</td>
                                    <td>{item.quantityReceived}</td>
                                    <td>{item.unit}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ViewGrnModal;